<template>
    <v-card v-if="activeTab != 0">
        <v-container class="mx-5 my-0">
            <v-row>
                <v-col cols="auto" class="px-0">
                    <v-tooltip location="top" color="secondary">
                        <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" @click="copyCodeToClipboard"
                                >mdi-content-copy</v-icon
                            >
                        </template>
                        <span>Copy to clipboard</span>
                    </v-tooltip>
                </v-col>

                <v-col>
                    <v-card-text class="pa-0 text-pre-wrap">
                        {{ text }}
                    </v-card-text>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>
<script setup>
const props = defineProps(['text'])

function copyCodeToClipboard() {
    navigator.clipboard.writeText(props.text)
}
</script>
